/**
 * Parses NEXT_PUBLIC_LOCAL_FEATURE_FLAGS env var into a PostHog bootstrap-compatible object.
 *
 * Usage: set in your app's .env.local file:
 *   NEXT_PUBLIC_LOCAL_FEATURE_FLAGS=ff-accounts-payable-enabled,ff-new-navbar-enabled
 *
 * This allows `useFeatureFlagEnabled` from posthog-js/react to work locally
 * without connecting to PostHog.
 */
export const getLocalFeatureFlags = (): Record<string, boolean> => {
  const raw =
    // eslint-disable-next-line alternative/no-invalid-env-usage
    process.env.NEXT_PUBLIC_LOCAL_FEATURE_FLAGS ?? ''

  if (!raw.trim()) return {}

  return raw
    .split(',')
    .map(flag => flag.trim())
    .filter(Boolean)
    .reduce<Record<string, boolean>>((acc, flag) => {
      acc[flag] = true
      return acc
    }, {})
}
